import { createFileRoute } from '@tanstack/react-router'
import { BomPage } from '@/features/bom/pages/BomPage'

export const Route = createFileRoute('/_app/bom/')({
  component: BomPage,
})
